import { render, staticRenderFns } from "./OPPending.vue?vue&type=template&id=2fa95e6a&"
import script from "./OPPending.vue?vue&type=script&lang=js&"
export * from "./OPPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports